import { toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f5e96846")

_pushScopeId("data-v-f5e96846")
const _hoisted_1 = { class: "title-1 center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "not-found" }, " La page qui vous voulez consulter n'existe pas. ", -1)
const _hoisted_3 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("dig-ui-title", _hoisted_1, _toDisplayString($setup.t('pageNotFound')), 1),
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("dig-ui-standard-button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goBack()))
      }, " Page précédente "),
      _createVNode("dig-ui-standard-button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goTo('/home')))
      }, " Retour accueil ")
    ])
  ], 64))
})